// extracted by mini-css-extract-plugin
export default {"carImage":"styles_carImage__p2V8P"};